import { StyleSheet, View } from 'react-native';

import { TextLink } from '@/components/atoms/link';
import { spacing } from '@/theme';

export interface ActionLinkItem {
  readonly label: string;
  readonly onPress: () => void;
  readonly disabled?: boolean;
}

export interface ActionLinkRowProps {
  readonly actions: readonly ActionLinkItem[];
  readonly testID?: string;
}

export const ActionLinkRow = ({ actions, testID }: ActionLinkRowProps) => {
  if (actions.length === 0) {
    return null;
  }

  return (
    <View style={styles.container} testID={testID}>
      {actions.map((action, index) => (
        <TextLink
          key={`${action.label}-${index}`}
          disabled={action.disabled}
          label={action.label}
          onPress={action.onPress}
          testID={testID ? `${testID}-action-${index}` : `action-link-row-action-${index}`}
        />
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    columnGap: spacing[4],
    marginHorizontal: -16,
    rowGap: spacing[1],
  },
});
